import React, {Component} from 'react'
// import * as firebase from 'firebase';
import firebase from '../helper/firebase'

import Downshift from 'downshift'

import {
  Button,
  Card,
  CardContent,
  Paper,
  TextField,
} from 'material-ui'

import List,{ListItem,ListItemText} from 'material-ui/List'

import CancelIcon from 'material-ui-icons/Cancel'
import EditIcon from 'material-ui-icons/Edit'
import SaveIcon from 'material-ui-icons/Save'

import Fade from 'material-ui/transitions/Fade'

import {
  bgWhite,
  LightGray,
  Industries,
  Functions,
} from '../helper/consts'

const style = {
  autoSuggestRow:{
    display:'flex',
    // flexDirection:'row',
    alignItems:'center',
  },
  profileRow:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
  },
  profileBtnContainer:{
    display:'flex',
    flexDirection:'row',
    flexWrap:'nowrap',
  },
  smallBtn:{
    minWidth:'32px',
  },
  inactiveSmallBtn: {
    minWidth:'32px',
    color:LightGray,
  },
  inputText:{
    color:'initial',
  },
}

export default class ProfileIndustryCard extends Component{
  constructor(props){
    super(props);

    this.state = {
      industries: Industries,
      functions: Functions,
      profile: this.props.profile,
      new_industry: this.props.profile && this.props.profile.industry,
      new_function: this.props.profile && this.props.profile.function,
    }
  }

  handleFormInput=(e,formField) => this.setState({[`${formField}`]:e.target.value})

  autocompleteSelect=(item,formField) => this.setState({[`${formField}`]:item})

  saveProfile=(profileDetail)=>{
    const {profile} = this.props;
    let promises = [];
    let newDetail = this.state[`new_${profileDetail}`]
    let oldDetail = this.state.profile[profileDetail]
    if(oldDetail!==newDetail && profileDetail!=='photoURL'){
      const ref = firebase.database().ref();
      const dbPromise = ref.child(`users/${profile.uid}`).update({[profileDetail]:newDetail})
      promises.push(dbPromise)
    }
    Promise.all(promises)
    .then(()=>{
      profile[profileDetail]=newDetail;
      this.setState({profile,[`edit_${profileDetail}`]:false})
    })
    .catch(err=>{
      console.log(err);
    })
  }

  onChange=()=>{}

  renderIndustrySuggestion=()=>{
    return(
      <Downshift
        onChange={e=>{this.autocompleteSelect(e,'new_industry')}}
        defaultInputValue={this.state.edit_industry?this.state.new_industry:this.state.profile.industry || ''}
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex,
        }) => (
          <div style={{width:'100%'}} className="industry">
            <TextField
              style={this.state.edit_industry?null:style.inputText}
              error={this.state.industryError}
              fullWidth
              id="industry"
              label="Industry"
              value={this.state.edit_industry?this.state.new_industry:this.state.profile.industry || ''}
              onChange={e=>{this.handleFormInput(e,'new_industry')}}
              margin="normal"
              disabled={!this.state.edit_industry}
              {...getInputProps({placeholder: 'E.g. Software'})}
            />

            {isOpen && (
              <Paper>
                <List>
                  {this.state.industries
                  .filter( item => !inputValue || item.toLowerCase().includes(inputValue.toLowerCase()))
                  .map((item, index) => (
                    <ListItem
                      key={item}
                      button
                      {...getItemProps({item})}
                      style={{
                        backgroundColor: highlightedIndex === index ? LightGray : bgWhite,
                        fontWeight: selectedItem === item ? 'bold' : 'normal',
                      }}
                    >
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </div>
        )}
      />
    )
  }

  renderFunctionSuggestion=()=>{
    return(
      <Downshift
        onChange={e=>{this.autocompleteSelect(e,'new_function')}}
        defaultInputValue={this.state.edit_function?this.state.new_function:this.state.profile.function || ''}
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          selectedItem,
          highlightedIndex,
        }) => (
          <div style={{width:'100%'}} className="function">
            <TextField
              style={this.state.edit_function?null:style.inputText}
              error={this.state.functionError}
              fullWidth
              id="function"
              label="Function"
              value={this.state.edit_function?this.state.new_function:this.state.profile.function || ''}
              onChange={e=>{this.handleFormInput(e,'new_function')}}
              margin="normal"
              disabled={!this.state.edit_function}
              {...getInputProps({placeholder: 'E.g. Software'})}
            />

            {isOpen && (
              <Paper>
                <List>
                  {this.state.functions
                  .filter( item => !inputValue || item.toLowerCase().includes(inputValue.toLowerCase()))
                  .map((item, index) => (
                    <ListItem
                      key={item}
                      button
                      {...getItemProps({item})}
                      style={{
                        backgroundColor: highlightedIndex === index ? LightGray : bgWhite,
                        fontWeight: selectedItem === item ? 'bold' : 'normal',
                      }}
                    >
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </div>
        )}
      />
    )
  }

  render(){
    // console.log(this.props);
    return(
      <Fade key='additional_profile_details' in={!!this.state.profile}>
        <Card className="card">
          <CardContent>
            <div style={style.profileRow} className="function">
              {this.renderIndustrySuggestion()}
              <div style={style.profileBtnContainer}>
                {this.state.edit_industry?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.saveProfile('industry')}} disabled={this.state.profile.industry===this.state.new_industry || this.state.new_industry.length===0} ><SaveIcon/></Button>:null}
                {this.state.edit_industry?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_industry:false})}} ><CancelIcon /></Button>:null}
                {!this.state.edit_industry?<Button style={style.inactiveSmallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_industry:true})}} ><EditIcon /></Button>:null}
              </div>
            </div>
            <div style={style.profileRow} className="function">
              {this.renderFunctionSuggestion()}
              <div style={style.profileBtnContainer}>
                {this.state.edit_function?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.saveProfile('function')}} disabled={this.state.profile.function===this.state.new_function || this.state.new_function.length===0} ><SaveIcon /></Button>:null}
                {this.state.edit_function?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_function:false})}} ><CancelIcon /></Button>:null}
                {!this.state.edit_function?<Button style={style.inactiveSmallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_function:true})}} ><EditIcon /></Button>:null}
              </div>
            </div>
          </CardContent>
        </Card>
      </Fade>
    )
  }
}

// <div style={style.profileRow} className="industry">
//   <TextField
//     style={this.state.edit_industry?null:style.inputText}
//     error={this.state.industryError}
//     fullWidth
//     id="industry"
//     label="Industry"
//     placeholder="E.g. Software"
//     value={this.state.edit_industry?this.state.new_industry:this.state.profile.industry || ''}
//     onChange={e=>{this.handleFormInput(e,'new_industry')}}
//     margin="normal"
//     disabled={!this.state.edit_industry}
//   />
//   <div style={style.profileBtnContainer}>
//     {this.state.edit_industry?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.saveProfile('industry')}} disabled={this.state.profile.industry===this.state.new_industry || this.state.new_industry.length===0} ><SaveIcon/></Button>:null}
//     {this.state.edit_industry?<Button style={style.smallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_industry:false})}} ><CancelIcon /></Button>:null}
//     {!this.state.edit_industry?<Button style={style.inactiveSmallBtn} className='cardActionsBtn' dense={true} onClick={()=>{this.setState({edit_industry:true})}} ><EditIcon /></Button>:null}
//   </div>
// </div>



// WEBPACK FOOTER //
// ./src/components/ProfileIndustryCard.js